import { render } from "./Minion.vue?vue&type=template&id=6159f592&scoped=true&ts=true"
import script from "./Minion.vue?vue&type=script&lang=ts"
export * from "./Minion.vue?vue&type=script&lang=ts"

import "./Minion.vue?vue&type=style&index=0&id=6159f592&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6159f592"]])

export default __exports__